module.exports = __webpack_public_path__ + "static/ssm-instance-entry-2f76084ab55992c4814114526b7d9283.png";